import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  game_list: []
};

const gameStateSlice = createSlice({
  name: 'game',
  initialState: initialState,
  reducers: {
    listGame: (state, action) => {
      state.game_list=  [...state.game_list, ...action.payload]
      
    },
    resetListGame: (state, action) => {
      state.game_list = []
    }
  }
});

export const { listGame, resetListGame } = gameStateSlice.actions;

export default gameStateSlice.reducer;